<template>
  <el-dialog :visible.sync="visible" :show-close="true" :close-on-click-modal="false" :fullscreen="true"
    :append-to-body="true" @opened="getData(false)" :before-close="beforeClose">
    <div v-if="data">
      <Plan ref="plan" :data="data" :needShow2MatchBtn="needShow2MatchBtn" :refresh="() => getData(true)"
        :closeFun="closeFun" :testMode="testMode" :orderIds="orderIds" :order="order" :ignoreWarning="ignoreWarning" />
    </div>
  </el-dialog>
</template>

<script>
import { getRoutePlan, getTestRoutePlan, prepareForTestRoutePlan } from "@/api";
import Plan from "./Plan.vue";
import { SessionStorage } from "@/util";
import { ROUTE_PLAN_MAP } from "@/core/const/global-const";
export default {
  components: {
    Plan
  },

  data() {
    return {
      visible: false,
      data: null,
      needShow2MatchBtn: false,
      testMode: false,
      order: null,
      routeId: null,
      orderIds: null,
      ignoreWarning: false
    };
  },

  methods: {
    show(route, needShow, order) {
      this.needShow2MatchBtn = needShow;
      this.route = route;
      this.testMode = false;
      this.order = order;
      this.visible = true;
      this.callback = null;
    },

    showTest(routeId, orderIds, clearCache = false, callback) {
      this.testMode = true;
      this.routeId = routeId;
      this.orderIds = orderIds;
      this.order = null;
      this.callback = callback;

      if (clearCache) {
        SessionStorage.clear(ROUTE_PLAN_MAP);
      }

      // 为模拟派单做准备
      prepareForTestRoutePlan(routeId, orderIds).then((res) => {
        if (res.data) {
          this.$confirm(res.data + "，是否继续派单？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.ignoreWarning = true;
            this.visible = true;
          });
        } else {
          this.visible = true;
        }
      });
    },

    getData(forceRefresh = false) {
      if (!this.testMode) {
        const { id } = this.route;
        getRoutePlan(id).then((res) => {
          this.data = res.data;
          this.$nextTick(() => {
            if (this.$refs.plan) {
              this.$refs.plan.initData && this.$refs.plan.initData();
              this.$refs.plan.queryShuntList && this.$refs.plan.queryShuntList();
            }
          });
        });
      } else {
        const { routeId, orderIds } = this;
        const cacheKey = this.getCacheKey();
        const map = SessionStorage.get(ROUTE_PLAN_MAP) || {};
        if (map[cacheKey] && !forceRefresh) {
          this.data = map[cacheKey];
          this.$nextTick(() => {
            if (this.$refs.plan) {
              this.$refs.plan.initData && this.$refs.plan.initData();
              this.$refs.plan.queryShuntList && this.$refs.plan.queryShuntList();
            }
          });
        } else {
          getTestRoutePlan(routeId, orderIds).then((res) => {
            this.data = res.data;
            map[cacheKey] = this.data;
            SessionStorage.set(ROUTE_PLAN_MAP, map);
            this.$nextTick(() => {
              if (this.$refs.plan) {
                this.$refs.plan.initData && this.$refs.plan.initData();
                this.$refs.plan.queryShuntList && this.$refs.plan.queryShuntList();
              }
            });
          });
        }
      }
    },

    closeFun(finishedPlan = false) {
      if (this.callback) {
        this.callback(finishedPlan);
      }
      this.visible = false;
    },

    beforeClose(done) {
      done && done();
    },

    getCacheKey() {
      return `${this.routeId}_${this.orderIds.join(",")}`;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  padding: 0;
}
</style>
